/** Правила сложности пароля (синхронно с backend tenders/password_policy.py). */

export const PASSWORD_MIN_LENGTH = 8

export function passwordPolicyChecks(password) {
  const p = String(password || '')
  return {
    minLength: p.length >= PASSWORD_MIN_LENGTH,
    hasDigit: /\d/.test(p),
    hasLower: /[a-zа-яё]/.test(p),
    hasUpper: /[A-ZА-ЯЁ]/.test(p),
  }
}

export function isPasswordPolicyMet(password) {
  const c = passwordPolicyChecks(password)
  return c.minLength && c.hasDigit && c.hasLower && c.hasUpper
}

export function passwordPolicyErrors(password) {
  const c = passwordPolicyChecks(password)
  const errors = []
  if (!c.minLength) errors.push(`Минимум ${PASSWORD_MIN_LENGTH} символов`)
  if (!c.hasDigit) errors.push('Хотя бы одна цифра')
  if (!c.hasLower) errors.push('Хотя бы одна строчная буква')
  if (!c.hasUpper) errors.push('Хотя бы одна заглавная буква')
  return errors
}

export function passwordStrengthScore(password) {
  const c = passwordPolicyChecks(password)
  let score = 0
  if (c.minLength) score += 1
  if (c.hasDigit) score += 1
  if (c.hasLower) score += 1
  if (c.hasUpper) score += 1
  const p = String(password || '')
  if (p.length >= 12) score += 1
  return Math.min(score, 5)
}

export function passwordStrengthLabel(score) {
  if (score <= 1) return 'Слабый'
  if (score <= 3) return 'Средний'
  if (score === 4) return 'Хороший'
  return 'Надёжный'
}
